import { render, staticRenderFns } from "./DetectionDetailLink.vue?vue&type=template&id=a32b0806&scoped=true&"
import script from "./DetectionDetailLink.vue?vue&type=script&lang=js&"
export * from "./DetectionDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b0806",
  null
  
)

export default component.exports